import Udesk from 'Udesk';

export const computeTotalScore = (task, pointCategoryList) => {
    task._minScore = 0;
    task._maxScore = 0;

    // 计算各级分值
    for (let i = 0; i < pointCategoryList.length; i++) {
        let firstCategory = pointCategoryList[i];
        firstCategory._minScore = 0;
        firstCategory._maxScore = 0;

        if (firstCategory.children && firstCategory.children.length > 0) {
            for (let j = 0; j < firstCategory.children.length; j++) {
                let secondaryCategory = firstCategory.children[j];
                // 计算各个二级分值
                Udesk.business.scoreCompute.computeSecondaryCategoryLimitScore(secondaryCategory);

                // 累计最大值与最小值
                firstCategory._minScore += secondaryCategory._minScore;
                firstCategory._maxScore += secondaryCategory._maxScore;
            }
        }

        // 计算一级最终分值
        Udesk.business.scoreCompute.computeFinalLimitScore(firstCategory);

        // 累计质检任务的最大值与最小值
        task._minScore += firstCategory._minScore;
        task._maxScore += firstCategory._maxScore;
    }

    return { task, pointCategoryList };
};
